/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTrashBin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.592 2.25a.279.279 0 0 0-.28.28v.845h3.375v-.846a.277.277 0 0 0-.28-.28H7.591ZM4.536 4.5l.666 10.652a.43.43 0 0 1 0 .007c.02.378.271.59.564.59h6.468c.29 0 .54-.207.564-.596L13.464 4.5H4.536Zm9.521-1.125h-2.245v-.843a1.404 1.404 0 0 0-1.406-1.407H7.594a1.404 1.404 0 0 0-1.407 1.407v.843H2.814a.563.563 0 0 0 0 1.125h.596l.67 10.72c.049.92.743 1.655 1.687 1.655h6.468c.953 0 1.631-.742 1.687-1.653L14.59 4.5h.597a.562.562 0 1 0 0-1.125h-1.121a.72.72 0 0 0-.01 0ZM6.45 5.625a.562.562 0 0 1 .582.542l.281 7.875a.562.562 0 0 1-1.124.04l-.281-7.875a.563.563 0 0 1 .542-.582Zm5.102 0c.31.011.553.272.542.582l-.28 7.876a.562.562 0 1 1-1.125-.04l.281-7.876a.563.563 0 0 1 .582-.542ZM9 5.625c.31 0 .563.252.563.562v7.875a.563.563 0 0 1-1.126 0V6.187c0-.31.252-.562.563-.562Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgTrashBin;
